// extracted by mini-css-extract-plugin
export default {"icon":"zcJy1NyHeerrD3tNUfsA","icon--no-title":"UBBUktWesN_js6dYj2hr","imageContainer":"OyWHBn_9OYpugnwBtNuC","text":"W7_h2vCKyiVnnT2Cpsdv","title":"dFwnuICHm60VtQu5FFyP"};